






































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Decisions from "@/store/modules/Decisions";
import DecisionManagerActions from "@/components/decisions/DecisionManagerActions.vue";
import DecisionManagerAppletMenu from "@/components/decisions/DecisionManagerAppletMenu.vue";
import moment from 'moment';
import { Urls } from "@/Urls";
import { type } from "os";

const decisionsModule = getModule(Decisions);

@Component({
    name: 'DecisionTable',
    components: {
        DecisionManagerActions,
        DecisionManagerAppletMenu
    }
})
export default class DecisionTable extends Vue {
    @Prop({type: Array, default: () => []})
    decisionItems: any[];

    @Prop({type: Array, default: () => []})
    decisionNames: any[];

    @Prop({ default: 0, type: Number })
    depth!: number;

    @Prop()
    searchTerm: string;

    @Prop()
    isDesc: boolean;

    @Prop()
    sortIndex: string;

    @Prop({ default: false, type: Boolean })
    list: boolean;

    @Prop({ default: false, type: Boolean })
    expanded: boolean;

    @Prop({ default: true, type: Boolean })
    expandable: boolean;

    private sortedIndex = 'name';
    private sortDesc = false;

    private appMap = [];

    private copiedTooltip = '';

    private expandedItems = [];
    private headersFolders = [
        {
            text: '',
            value: 'actions',
            sortable: false,
            width: '40px'
        },
        {text: 'Name', value: 'name', width: '210px'},
        {text: 'Created', value: 'creationTimestamp', width: '140px'},
        {text: 'Last Edit', value: 'lastUpdatedTimestamp', width: '140px'},
        {text: 'Description', value: 'description', width: 'calc(100% - 622px)'},
        
    ];

    private headersList = [
        {
            text: '',
            value: 'actions',
            sortable: false,
            width: '40px'
        },
        {text: 'Name', value: 'name', width: '242px'},
        {text: 'Source', value: 'decisionTemplateName', width: '150px' },
        {text: 'Created', value: 'creationTimestamp', width: '140px'},
        {text: 'Last Edit', value: 'lastUpdatedTimestamp', width: '140px'},
        {text: 'Description', value: 'description', width: '242px'},

    ];

    get headers() {
        if (this.list) {
            return this.headersList;
        }
        return this.headersFolders;
    }

    get tableItems() {
        return [...new Set( this.decisionItems )];
    }

    private formatDate(dateString: string) {
        return moment(dateString).format('YYYY-MM-DD');
    }

    private highlightRow(item: any) {
        
        if (this.searchTerm != '' && this.searchTerm != null) {
            const nameCheck = item.name.toLowerCase().includes(this.searchTerm.toLowerCase());
            if (this.list) {
                if (this.decisionNames[item.decisionTemplateId]) {
                    const templateCheck = this.decisionNames[item.decisionTemplateId].toLowerCase().includes(this.searchTerm.toLowerCase());
                    return nameCheck || templateCheck;
                }
            }
            return nameCheck;
        }
        return false;
    }

    private copy(id: string) {
        this.copiedTooltip = id;
        setTimeout(() => (this.copiedTooltip = ''), 2500);
    }

    private checkDropdown(item: any) {
        return item.apps && item.apps.length > 0
    }

    private getAppsUrl(url: string) {

        let mainPath = Urls.APP_EMBED;
        // Remove trailing '/' if there
        mainPath = mainPath.charAt(mainPath.length - 1) == '/' ? 
            mainPath.substr(0, mainPath.length - 1) : mainPath

        let re = new RegExp(
            '^(http:|https:){1}[/]{2}([a-zA-Z0-9.:-]*[/]{0})([/]{1}[/]*){1}'
        );
        if (re.test(url)) {
            url = mainPath + url.replace(re, '/');
            // console.log(url);
            return url;
        } else {
            // console.log(url);
            return mainPath + url;
        }
    }

    private generateLink(item: any) {
        let link = '';
        if(item.children && item.children.length > 0) {
            link = `${link}${this.getAppsUrl(item?.children[0].href)}`;
            link = `${link}&homepage=${item.homepage && item.showHomepage}&pinnedLeft=true&appEmbedId=${item.id}&appEmbedMenuId=${item.id}`
            return 'https://viewpoint-ai.com/launch?' + encodeURIComponent(link);
        }
    }

    private removeTags(str: string) {
        if ((str===null) || (str==='')) {
            return false;
        }
        else {
            str = str.toString();
        }
        // Regular expression to identify HTML tags in 
        // the input string. Replacing the identified 
        // HTML tag with a null string.
    return str.replace( /(<([^>]+)>)/ig, '');
    }

    mounted() {
        this.onExpandChanged(this.expanded);
    }

    @Watch('isDesc')
    onSortChanged(val) {
        this.sortDesc = val;
    }

    @Watch('sortIndex')
    onSortedIndexChanged(val) {
        this.sortedIndex = val;
    }

    @Watch('expanded')
    onExpandChanged(val) {
        if (val) {
            this.expandedItems = this.tableItems.filter((item) => {
                if (item.apps) {
                    if ( item.apps.length > 0 ) {
                        return true;
                    }
                }
                return false;
            });
        } else {
            this.expandedItems = [];  
        }
    }
}
